module.exports = __webpack_public_path__ + "img/a28.e3e2c68a.svg";